// this component must be used in Row block
import { Icon } from '@common';
import './input.less';

export const CISInput = props => {
    const { iconClassName = '', placeholder = '', hasButton = false, type = 'text', onChange, classNames, value = '', isChangeRed, disabled = false } = props;

    return (
        <>
            <Icon className={iconClassName} id="icon-input" ></Icon>
            <R.Input
                type={type}
                attrs={{ 'aria-labelledby': placeholder, 'style': `${hasButton ? 'padding-right:185px' : ''};${isChangeRed && 'border-bottom: 1px solid #c91d1d;outline: none !important;border-color: #c91d1d !important;'}${disabled && "font-size:20px;color:#000;"}` }}
                placeholder={placeholder}
                onChange={onChange}
                className={`inputCommon ${classNames}`}
                value={value}
                maxlength={257}
                disabled={disabled}
                {...props}
            />
        </>);
};

export const CISPasswordInput = props => {
    const { iconClassName = '', placeholder = '', hasButton = false, type = 'text', onChange, classNames, isChangeRed } = props;

    return (
        <>
            <Icon className={iconClassName} id="icon-input" ></Icon>
            <R.Input
                type={type}
                attrs={{ 'aria-labelledby': placeholder, 'style': `${hasButton ? 'padding-right:185px' : ''};${isChangeRed && 'border-bottom: 1px solid #c91d1d;outline: none !important;border-color: #c91d1d !important;'}` }}
                placeholder={placeholder}
                onChange={onChange}
                className={`inputCommon ${classNames}`}
                maxlength={257}
                {...props}
            />
        </>);
};